import { useState } from 'react';
import { Star } from 'lucide-react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import api from '@/lib/api';
import { useToast } from '@/hooks/useToast';

interface ReviewFormProps {
  produtoId: string;
  pedidoId: string;
  onSuccess?: () => void;
}

export function ReviewForm({ produtoId, pedidoId, onSuccess }: ReviewFormProps) {
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);
  const [nota, setNota] = useState(5);
  const [hover, setHover] = useState(0);
  const [titulo, setTitulo] = useState('');
  const [comentario, setComentario] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.post('/reviews', {
        produtoId,
        pedidoId,
        nota,
        titulo,
        comentario
      });

      toast({
        title: 'Avaliação enviada!',
        description: 'Obrigado por seu feedback. Você ganhou 50 pontos no Fort3D Club!',
      });
      
      if (onSuccess) onSuccess();
    } catch (error: any) {
      toast({
        title: 'Erro ao avaliar',
        description: error.response?.data?.error || 'Tente novamente mais tarde.',
        variant: 'destructive'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm space-y-4">
      <h3 className="text-lg font-bold text-gray-900">Avalie este produto</h3>
      
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            type="button"
            className="focus:outline-none"
            onClick={() => setNota(star)}
            onMouseEnter={() => setHover(star)}
            onMouseLeave={() => setHover(0)}
          >
            <Star
              className={`w-6 h-6 transition-colors ${
                (hover || nota) >= star ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'
              }`}
            />
          </button>
        ))}
      </div>

      <div className="space-y-2">
        <label className="text-sm font-medium text-gray-700">Título</label>
        <Input 
          placeholder="Ex: Incrível, ótima qualidade!" 
          value={titulo}
          onChange={(e) => setTitulo(e.target.value)}
          required
        />
      </div>

      <div className="space-y-2">
        <label className="text-sm font-medium text-gray-700">Comentário</label>
        <textarea
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent min-h-[100px]"
          placeholder="Conte para outros clientes o que achou do produto..."
          value={comentario}
          onChange={(e) => setComentario(e.target.value)}
          required
        />
      </div>

      <Button type="submit" className="w-full" disabled={loading}>
        {loading ? 'Enviando...' : 'Publicar Avaliação'}
      </Button>
    </form>
  );
}
